<ripple-entity-details [entity]="filterEntity" [hideButtons]="true"
    [generatorOptions]="generatorOptions" [fieldOrders]="fieldOrders">
</ripple-entity-details>
<div class="button-nav button-nav--justify-end">
    <ripple-button-list [buttons]="splitButtons"></ripple-button-list>
</div>
